
export async function checkAuth (targetAPI) {
   return new Promise ( async (resolve,reject) => {
       let headers = new Headers();
       headers.append("token", localStorage.getItem('token'));
       headers.append("target-api", targetAPI);


       let requestOptions = {
           method: 'GET',
           headers: headers,
       };
       try {
           const url = process.env.REACT_APP_SERVER_API_HOST+"/auth"
           const response = await fetch(url,requestOptions);
           if (!response.ok) {
               console.error(new Error(`Response status: ${response.status}`))
           }
           const json = await response.json();
           resolve(json)
       }
       catch (e) {
           resolve(null)
       }
   })
}

export async function doConfirmEmailToken (confirmEmailToken) {
    return new Promise ( async (resolve,reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json')
        headers.append("token", localStorage.getItem('token'));
        let requestOptions = {
            method: 'POST',
            headers: headers,
            body:JSON.stringify({confirmEmailToken:confirmEmailToken})
        };
        try {
            const url = process.env.REACT_APP_SERVER_API_HOST+"/auth/confirm-email-token"
            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const json = await response.json();
            resolve(json)
        }
        catch (e) {
            console.error(e)
            resolve(null)
        }
    })
}

export function isSignedIn (appState) {
    return !appState.user.isAnonymous && appState.user.uuid
}
